const listeners = new Set();

export const subscribeToAuthEvents = (listener) => {
  if (typeof listener !== 'function') {
    throw new Error('Auth event listener must be a function.');
  }
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const emitAuthEvent = (event) => {
  listeners.forEach((listener) => {
    try {
      listener(event);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Auth event listener failed', error);
    }
  });
};

// Test-only helper to clear all listeners (prevents cross-test interference)
export const _clearListeners = () => listeners.clear();

export const AUTH_EVENT_TYPES = {
  UNAUTHORIZED: 'unauthorized',
  PROFILE_UPDATED: 'profile_updated',
  FORBIDDEN: 'forbidden',
  RATE_LIMITED: 'rate_limited',
};
